export const emptyValue = (value: any) => {
  const nullishOrValue = value ?? ''
  return nullishOrValue === '' ? '-' : value
}

export const toTime = (value: string) => {
  const date = new Date(value)
  const MONTH = date.toLocaleString('en', { month: 'short' })
  return `${date.getDate()}. ${MONTH}. ${date.getFullYear()}`
}

export const toUpperCaseFirstChar = (value: string) => {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export const truncate = (value: string) => {
  const max = 48
  if (value?.length > max) {
    return value.slice(0, max - 4) + ' ...'
  } else {
    return value
  }
}

export const toMegaBytes = (bytes: number) => {
  return `${(bytes / 1000000).toFixed(1)} MB`
}
